import React from 'react';
import Icon from '../../../components/AppIcon';

const CommunityImpact = () => {
  const impactStats = [
    {
      icon: "Users",
      number: "50+",
      label: "Jobs Created",
      description: "Providing employment opportunities across Bengaluru"
    },
    {
      icon: "Store",
      number: "15+",
      label: "Local Suppliers",
      description: "Supporting Karnataka farmers and businesses"
    },
    {
      icon: "Heart",
      number: "100K+",
      label: "Happy Customers",
      description: "Serving diverse communities with authentic flavors"
    },
    {
      icon: "Leaf",
      number: "Zero",
      label: "Food Waste Goal",
      description: "Committed to sustainable practices and donations"
    }
  ];

  const initiatives = [
    {
      title: "Local Supplier Partnerships",
      description: "We work directly with 15+ local farmers and suppliers across Karnataka, ensuring fair prices and supporting local agriculture. Our partnerships include vegetable farmers from Kolar, dairy cooperatives from Hassan, and spice traders from Mysuru.",
      icon: "Handshake",
      color: "var(--color-trust-green)"
    },
    {
      title: "Community Employment",
      description: "Taco Street has created 50+ jobs across Bengaluru, with 70% of our team members being local residents. We provide competitive wages, skill training, and career growth opportunities in the hospitality industry.",
      icon: "Briefcase",
      color: "var(--color-primary)"
    },
    {
      title: "Food Donation Program",
      description: "Partnering with local NGOs, we donate surplus food daily to communities in need. Our zero-waste initiative ensures that quality food reaches those who need it most, reducing waste while serving the community.",
      icon: "Gift",
      color: "var(--color-accent)"
    },
    {
      title: "Cultural Bridge Building",
      description: "We host monthly cultural events celebrating both Mexican and Indian food traditions, creating spaces for community connection and cultural appreciation. These events feature cooking demonstrations, music, and storytelling.",
      icon: "Globe",
      color: "var(--color-brand-amber)"
    }
  ];

  return (
    <section className="py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-4xl sm:text-5xl font-bold text-foreground mb-4">
            Community <span className="text-primary">Impact</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Building connections beyond the plate
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {impactStats?.map((stat, index) => (
            <div
              key={index}
              className="bg-card p-6 rounded-xl border border-border text-center hover:border-primary transition-all duration-300 hover:shadow-md animate-slide-up"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
                <Icon name={stat?.icon} size={32} color="var(--color-primary)" />
              </div>
              <div className="text-4xl font-bold text-primary mb-2">{stat?.number}</div>
              <div className="text-lg font-semibold text-foreground mb-1">{stat?.label}</div>
              <p className="text-sm text-muted-foreground">{stat?.description}</p>
            </div>
          ))}
        </div>

        <div className="space-y-8">
          {initiatives?.map((initiative, index) => (
            <div
              key={index}
              className="bg-card p-8 rounded-xl border border-border hover:border-primary transition-all duration-300 hover:shadow-md animate-fade-in"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="flex items-start gap-6">
                <div className="w-16 h-16 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: `${initiative?.color}15` }}>
                  <Icon name={initiative?.icon} size={32} color={initiative?.color} />
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-semibold text-foreground mb-3">{initiative?.title}</h3>
                  <p className="text-muted-foreground leading-relaxed text-lg">{initiative?.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CommunityImpact;